export default __webpack_public_path__ + "static/internet2-ff4b5a7402ad1258b10338072fb165d2.png";